import Request from "./Request";
import store from "app/redux/store";
import { BASE_URL } from "./Config";

class API {
  getDeviceFingerprint = () => store.getState().user.deviceFingerprint;

  get = (path, params) => {
    const url = `${BASE_URL}${path}`;
    return Request.get(url);
  };

  post = (path, data) => {
    const deviceFingerprint = this.getDeviceFingerprint();
    let urlEncodedData = [];
    for (let key in data) {
      urlEncodedData = [...urlEncodedData, `${key}=${data[key]}`];
    }

    urlEncodedData = urlEncodedData.join("&");
    urlEncodedData = `${urlEncodedData}&dfh=${deviceFingerprint.hash}`;

    const url = `${BASE_URL}${path}`;
    return Request.post(url, urlEncodedData);
  };
}

const ap = new API();
export default ap;
